import './Footer.css';
import React from 'react';
import mappers from './assets/mappers.png'; // Make sure to provide the correct path

function Footer({ isEnglish }) {
  console.log(isEnglish)
  return (
    <footer>
      <div className='footer'>
        <span>&copy;
          {isEnglish
            ? '2024, Government of Sudurpashchim Province, All Rights Reserved'
            : '२०२४, सुदूरपश्चिम प्रदेश सरकार, सबै अधिकार प्राप्त '}
        </span>
        <div className='mappers'>
          <img src={mappers} alt='logo' className='mappers-logo' />
          <a href='https://mappersnepal.com.np/'>
            {isEnglish ? 'Developed by Mappers Nepal' : 'म्यापर्स नेपाल द्वारा विकसित'}
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
